export const REVIEW_ROUTE = '/fund/overview';
export const CAPITAL_FUND_ROUTE = '/capital-fund-grantee/';
export const REQUEST_GRANT_ROUTE = '/request-a-grant';
export const PHONE_VALIDATION_REGEX = /^((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/; //eslint-disable-line
export const EIN_REGEX = /^\d{2}\-?\d{7}$/; //eslint-disable-line
